import React from 'react';
import { Card } from './ui/card';
import { Star, Quote } from 'lucide-react';

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Maria Rodriguez',
      location: 'Madrid, Spain',
      rating: 5,
      text: 'Exceptional service! VISA INTELLIGENCE made my Mexican visa application process incredibly smooth. They handled everything professionally and I received my visa without any issues.',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop'
    },
    {
      name: 'James Thompson',
      location: 'Manchester, UK',
      rating: 5,
      text: 'I was worried about the complexity of the visa process, but the team at VISA INTELLIGENCE guided me through every step. Their expertise and attention to detail gave me complete peace of mind.',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop'
    },
    {
      name: 'Sofia Chen',
      location: 'London, UK',
      rating: 5,
      text: 'Outstanding support from start to finish! The consultation was thorough, and document preparation was flawless. I highly recommend VISA INTELLIGENCE to anyone needing visa services.',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop'
    }
  ];

  return (
    <section id="testimonials" className="py-20 sm:py-24 lg:py-32 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-muted-foreground">
            Read about the experiences of those we've helped achieve their visa goals
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="p-6 hover:shadow-xl transition-all duration-300 border-2 hover:border-primary/30 flex flex-col">
              <Quote className="h-10 w-10 text-primary/20 mb-4" />
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-accent text-accent" />
                ))}
              </div>
              
              <p className="text-muted-foreground leading-relaxed mb-6 flex-grow">
                "{testimonial.text}"
              </p>
              
              <div className="flex items-center mt-auto">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-semibold text-foreground">{testimonial.name}</div>
                  <div className="text-sm text-muted-foreground">{testimonial.location}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
